// tslint:disable quotemark max-line-length
import { DmpHlFindPatientResponseSIns } from "src/app/utils/interfaces/new/dmp-hl-find-patient-response.interface";
import { DmpHlGetDirectAuthentificationDmpStatus } from "src/app/utils/interfaces/new/dmp-hl-get-direct-authentification-dmp-status.interface";
import { DmpHlGetInteropCodesEnum } from "src/app/utils/enums/dmp-hl-get-interop-codes-params.enum";
import { DmpHlGetInteropCodesResponse } from "src/app/utils/interfaces/new/dmp-hl-get-interop-codes-response.interface";
import { DmpHlGetWebPsUrlsResponse } from "src/app/utils/interfaces/new/dmp-hl-get-web-ps-urls-response.interface";
import { DmpHlUpdateUserAccessAuthorizationParams } from "src/app/utils/interfaces/new/dmp-hl-update-user-access-authorization-identity-params.interface";
import { DmpHlFindDocumentsParams } from "src/app/utils/interfaces/new/dmp-hl-find-documents-params.interface";
import { DmpHlFindDocumentsResponse } from "src/app/utils/interfaces/new/dmp-hl-find-documents-response.interface";
import { DmpHlGetDocumentContentParams } from "src/app/utils/interfaces/new/dmp-hl-get-document-content-params.interface";
import { DmpHlGetDocumentContentResponse } from "src/app/utils/interfaces/new/dmp-hl-get-document-content-response.interface";
import { DmpHlDeleteDocumentParams } from "src/app/utils/interfaces/new/dmp-hl-delete-document-params.interface";
import { DmpHlsendDocumentsDocument, DmpHlsendDocumentsParams } from "src/app/utils/interfaces/new/dmp-hl-send-documents-params.interface";
import { DmpHlAccessModeEnum, DmpHlSetDmpAccessModeParams } from "src/app/utils/interfaces/new/dmp-hl-set-dmp-access-mode-params.interface";
import { ViewContainerRef } from "@angular/core";
import { DmpVaccin } from "../vaccin/vaccin.service";
import { DmpHlArchiveDocumentParams } from "src/app/utils/interfaces/new/dmp-hl-archive-document-params.interface";
import { DmpGetMyDocumentsParams } from "src/app/utils/interfaces/new/dmp-get-my-documents-params.interface";
import { DmpGetMyDocumentsResult } from "src/app/utils/interfaces/new/dmp-get-my-documents-result.interface";
import { DmpHlVisibilityDocumentParams } from "src/app/utils/interfaces/new/dmp-hl-visibility-document-params.interface";
import { DmpGetLastAccessDateParams } from "src/app/utils/interfaces/new/dmp-get-last-access-date-params.interface";
import { UserInfosInstitutionDmp } from "./dmp.service";
import { DmpAddMyDocumentsParams } from "src/app/utils/interfaces/new/dmp-add-my-documents-params.interface";

// export const DMP_AUTO_TYPE = [
//   "11488-4", // CR ou fiche de consultation ou de visite
//   "11490-0", // Lettre de liaison à la sortie d'un établisement de santé
//   "18761-7", // Note de transfert (dont lettre de liaison à l'entrée en établissement de soins)
//   "34874-8", // CR opératoire
//   "75496-0", // Demande d'acte de télémedecine
//   "75497-8", // CR de télé-médecine
//   "85208-7", // CR de télémédecine
//   "CERT_DECL", // Certificat, déclaration
// ]

export const TYPE_TO_REMOVE = [
  "60591-5",       // Synthèse du dossier médical (VSM structuré CDA R2 N3 IPS-FR)
  "87273-9",       // Note de vaccination unitaire (CDA R2 N3 avec liaison Datamatrix)
  // Prescriptions / Ordonnances
  "57833-6",       // Prescription de produits de santé
  "57828-6",       // Prescription (autre)
  "57832-8",       // Prescription de soins
  "PRESC-BIO",     // Prescription d'actes biologie médicale
  "PRESC-KINE",    // Prescription d'acte de kinésithérapie
  "PRESC-INF",     // Prescription d'acte d'infirmier
  "PRESC-PEDI",    // Prescription d'acte de pédicurie
  "PRESC-ORTHOPHO",// Prescription d'acte d'orthophonie
  "PRESC-ORTHOPTIE",// Prescription d'acte d'orthoptie
  // Documents déposés par le patient 
  "DOCPAT01",      // Synthèse déposée patient
  "DOCPAT02",      // Traitement/document de soins déposé patient
  "DOCPAT03",      // CR déposé par le patient
  "DOCPAT04",      // Imagerie déposée par patient
  "DOCPAT05",      // CR de biologie déposé patient
  "DOCPAT06",      // CR de prévention déposé patient
  "DOCPAT07",      // Certificat déposé par le patient
  "DOCPAT08",      // Profil médical Mon espace santé
  "EXPPAT_1",      // Volontés et droits du patient
  "EXPPAT_2",      // Autre document du patient
  "EXPPAT_3",      // Directives anticipées
  // Systèmes, administratifs
  "11369-6",       // Historique de vaccinations (généré uniquement par le serveur DMP)
  "REMB",          // Données de remboursement (déposé uniquement par l'Assurance Maladie)
  "96173-0",       // Attestation de dépistage
  "96874-3",       // COVID-19 - Attestation de vaccination
  "E1762"          // FullDocument
];

// Cadres d'éxercice autorisés
export const PRACTICE_SETTING_CODES_AUTORIZED = [
  "AMBULATOIRE",  // Ambulatoire
  "MAD",  // Maintien à domicile
  "SAD",  // Soins à domicile
];

// Secteurs d'activité autorisés
export const SUBJECT_ROLE_CODES_AUTORIZED = [
  "SA05", // Centre de santé
  "SA07", // Cabinet individuel
  "SA08", // Cabinet de groupe
  "SA43", // Secteur non défini
  "SA50", // Permanence des soins ambulatoires hors cabinet
  "SA51", // Structure de coopération avec autorisation de soins
  "SA52", // Maison de santé ou Pôle de santé
];

export abstract class DmpServiceAbstract {
  resourceId: string;

  /**
   * Permet de connaître le statut d'un DMP (existant, autorisation d'accès, etc...)
   */
  abstract hl_getdirectauthentificationdmpstatus(view: ViewContainerRef, patientIns: string): Promise<DmpHlGetDirectAuthentificationDmpStatus>;

  /**
   * Met à jour l'autorisation d'accès au DMP pour le professionnel de santé
   */
  abstract hl_updateuserdmpaccessauthorization(view: ViewContainerRef, authorizationParams: DmpHlUpdateUserAccessAuthorizationParams): Promise<void>;

  /**
   * Renseigne le mode d'accès au DMP
   */
  abstract hl_setdmpaccessmode(view: ViewContainerRef, accessMode: DmpHlSetDmpAccessModeParams): Promise<void>;
  abstract accessMode: DmpHlAccessModeEnum;

  /**
   * Récupère les informations d'accès à l'espace Web PS
   */
  abstract hl_getwebpsdmpurls(view: ViewContainerRef, sIns: DmpHlFindPatientResponseSIns): Promise<DmpHlGetWebPsUrlsResponse>;

  /**
   * Récupère une liste de codes d'interopérabilité
   */
  abstract hl_getInteropCodes(view: ViewContainerRef, sCodeIds: Array<DmpHlGetInteropCodesEnum>): Promise<DmpHlGetInteropCodesResponse>;

  /**
   * Récupère des documents selon les paramètres de recherche
   */
  abstract hl_finddocuments(view: ViewContainerRef, ins: DmpHlFindPatientResponseSIns, searchParams: DmpHlFindDocumentsParams): Promise<Array<DmpHlFindDocumentsResponse>>;

  /**
   * Télécharge le document
   */
  abstract hl_getdocumentcontent(view: ViewContainerRef, downloadParams: DmpHlGetDocumentContentParams): Promise<DmpHlGetDocumentContentResponse>;

  /**
   * Supprime un document
   */
  abstract hl_deletedocument(view: ViewContainerRef, deleteParams: DmpHlDeleteDocumentParams, patientId?: string): Promise<void>;

  abstract getMyDocuments(myDocsParams: DmpGetMyDocumentsParams): Promise<Array<DmpGetMyDocumentsResult>>
  abstract deleteFromMyDocuments(uniqueId: string): Promise<void>;

  abstract getLastAccessDate(lastAccessParams: DmpGetLastAccessDateParams): Promise<Date | undefined>;
  abstract setLastAccessDate(lastAccessParams: DmpGetLastAccessDateParams): Promise<void>;

  /**
   * Archive ou désarchive un document
   * - si archivé, devient désarchivé
   * - si non archivé, devient archivé
   */
  abstract archiveDocumentByUniqueId(view: ViewContainerRef, archiveParams: DmpHlArchiveDocumentParams): Promise<void>

  abstract updateVisibilityDocumentByUniqueId(view: ViewContainerRef, archiveParams: DmpHlVisibilityDocumentParams): Promise<any>;

  abstract hl_getDocumentUuidByUniqueId(view: ViewContainerRef, documentInfos: { s_documentUniqueId: string, s_ins: DmpHlFindPatientResponseSIns }): Promise<string>;

  /**
   * Supprime un document
   */
  abstract hl_deleteArchivedDocument(view: ViewContainerRef, deleteParams: DmpHlDeleteDocumentParams, patientId?: string): Promise<void>;

  /**
   * Envoyer un fichier sur le DMP
   */
  abstract hl_senddocument(view: ViewContainerRef, sendingParam: DmpHlsendDocumentsParams, document: DmpHlsendDocumentsDocument, documentId?:string, patientId?: string): Promise<void>;

  /**
   * Envoyer des fichiers sur le DMP
   */
  abstract hl_senddocuments(view: ViewContainerRef, sendingParam: DmpHlsendDocumentsParams, documents: Array<DmpHlsendDocumentsDocument>, documentsId?:Array<string>, patientId?: string): Promise<void>;

  /**
   * On détruit l'instance de DMPConnector
   */
  abstract reinitializeConnector(view: ViewContainerRef): Promise<void>;


  /**
   * On ajoute une note de vaccination au DMP
   */
  abstract ajouterNoteDeVaccin(view: ViewContainerRef, sendingParam: DmpHlsendDocumentsParams, consumable: VaccinationConsumable, author: VaccinationVaccinator, vaccinator: VaccinationVaccinator, dateInjection: Date, vaccinId?: UpdateNoteVaccinationId, patientId?: string): Promise<DmpVaccin>;
  abstract deleteNoteDeVaccination(view: ViewContainerRef, deleteParams: DmpHlDeleteDocumentParams): Promise<void>;

  /**
   * On valide une vaccination ajoutée par un patient
   */
  abstract validerVaccin(view: ViewContainerRef, sendingParam: DmpHlsendDocumentsParams, vaccin: ValidationVaccination, patientId?: string): Promise<void>;

  /**
   * Rechercher une vaccination à valider (une vaccination akoutée par un patient)
   */
  abstract rechercherHistoriqueDeVaccination(view: ViewContainerRef, ins: DmpHlFindPatientResponseSIns): Promise<HistoriqueVaccination>;

  /**
   * Récupérer le contenu d'une vaccination
   */
  abstract getVaccinationContent(view: ViewContainerRef, documentHandle: number): Promise<any>;


  /**
   * Rechercher une vaccination à valider (une vaccination akoutée par un patient)
   */
  abstract rechercherVaccinAValider(view: ViewContainerRef, ins: DmpHlFindPatientResponseSIns): Promise<Array<VaccinAValider>>;


  /**
   * Retourne les codes CIS
   */
  abstract getCisCodes(view: ViewContainerRef, search?: string): Promise<Array<{ id: string, libelle: string }>>;

  /**
   * Retourne les codes ATC
   */
  abstract getAtcCodes(view: ViewContainerRef, search?: string): Promise<Array<{ id: string, libelle: string }>>;

  /**
   * Récupère les paramètres DMP depuis le serveur DMP
   */
  abstract getDmpParameters(view: ViewContainerRef): Promise<DmpParameters>;

  /**
   * Récupère l'âge de majorité paramétré sur le serveur DMP
   */
  abstract getMajorityAge(view: ViewContainerRef): Promise<number>;

  /**
   * Paramètrer le niveau de confidentialité d'accès au DMP d'un patient
   */
  abstract setConfidentialityLevel(view: ViewContainerRef, enable: boolean): Promise<void>;

  /**
   * Récupérer le niveau de confidentialité d'accès au DMP d'un patient
   */
  abstract getConfidentialityLevel(view: ViewContainerRef): Promise<boolean>;

  /**
   * Ajout dans mes documents
   */
  abstract addMyDocuments(myDocsParams: DmpAddMyDocumentsParams, uniqueId?: string): Promise<void>;

  abstract updateMyDocumentsDocumentId(uniqueId: string, documentId: string): Promise<void>;

  abstract searchDMPDocumentByDocumentId(list:Array<string>) : Promise<Array<{documentDmp:DmpGetMyDocumentsResult, documentId:string}>>;
}

export interface UpdateNoteVaccinationId {
  vaccinEntryId: string;
  vaccinUniqueId: string;
}

export interface DmpParameters {
  cumulMasquePsPatient: boolean,
  hrMaxSearchPeriod: number,
  majorityAge: number,
  minorFunctionManagement: boolean,
}

export interface DmpHp {
  Institution: DmpHpInstitution;
  i_hpAuthenticationMode: number;
  i_hpInternalIdType: number;
  s_hpGiven: string;
  s_hpInstitution: string;
  s_hpInternalId: string;
  s_hpName: string;
  s_hpProfession: string;
  s_hpProfessionDescription: string;
  s_hpProfessionOid: string;
  s_hpSpeciality: string;
  s_hpSpecialityDescription: string;
}

export interface DmpHpInstitution {
  s_classCode: string;
  s_id: string;
  s_name: string;
}

export interface HistoriqueVaccinationImmunizationsAuthor extends DmpHp {
  Institution: HistoriqueVaccinationImmunizationsAuthorInstitution;
}

export interface HistoriqueVaccinationImmunizationsAuthorInstitution extends DmpHpInstitution {}

export interface HistoriqueVaccinationImmunizationsConsumable {
  s_atcCode: string;
  s_atcCodeDescription: string;
  s_cipCode: string;
  s_cipCodeDescription: string;
  s_cisCode: string;
  s_cisCodeDescription: string;
  s_ucdCode: string;
  s_ucdCodeDescription: string;
  s_mvCode: string;
  s_mvCodeDescription: string;
  s_lotNumber: string;
  s_name: string;
}
export interface HistoriqueVaccinationImmunizations {
  Author: HistoriqueVaccinationImmunizationsAuthor;
  Consumable: HistoriqueVaccinationImmunizationsConsumable;
  Performer: HistoriqueVaccinationImmunizationsAuthor;
  i_approachSite: number;
  i_doseQuantity: number;
  i_immunizationRoute: number;
  i_rank: number;
  i_type: number;
  s_approachSiteDescription: string;
  s_date: string;
  s_entryId: string;
  s_immunizationRouteDescription: string;
  s_typeDescription: string;
  Comment: {
    s_text: string;
  };
}

export interface HistoriqueVaccinationStructuredBodySections {
  Immunizations: Array<HistoriqueVaccinationImmunizations>;
  i_type: number;
  s_title: string;
}

export interface HistoriqueVaccinationStructuredBody {
  Sections: Array<HistoriqueVaccinationStructuredBodySections>
}
export interface HistoriqueVaccination {
  Authors: Array<HistoriqueVaccinationImmunizationsAuthor>;
  StructuredBody: HistoriqueVaccinationStructuredBody;
  s_status: "OK";
}

export interface VaccinationConsumable {
  name: string;
  lotNumber: string;
  cisCode: string;
  cisCodeDescription: string;
  cipCode?: string;
  cipCodeDescription?: string;
  atcCode: string;
  atcCodeDescription: string;
  ucdCode?: string;
  ucdCodeDescription?: string;
  mvCode?: string;
  mvCodeDescription?: string;

  type?: string;
  route?: string;
  approachSite?: string;
  rank?: number;
  doseQty?: string;
  comment?: string;
}

export interface VaccinationVaccinator {
  hpName: string;
  hpGiven: string;
  hpProfession: string;
  hpProfessionOid: string;
  hpSpecialty?: string;
  hpInternalId: string;
  hpAuthenticationMode?: VaccinatorAuthenticationMode;
  hpInternalIdType: string;
  // Telecoms?: Array<VaccinatorTelecom>;
  // Addresses?: Array<VaccinatorAddress>;
  Institution: VaccinationInstitution;
}

export interface VaccinationInstitution extends UserInfosInstitutionDmp {}

export interface ValidationVaccination {
  cis: string;
  date: string;
  consumable: VaccinationConsumable;
  author: VaccinationVaccinator;
  vaccinator: VaccinationVaccinator;
}

export interface InfosVaccinAValider {
  cis: string;
  date: string;
}

export interface VaccinAValider extends InfosVaccinAValider {
  consumable: VaccinationConsumable;
  vaccinator: string;
  meta: HistoriqueVaccinationImmunizations;
}

export enum VaccinatorAuthenticationMode {
  "Numéro INS patient" = 1,
  "Numéro INS-C patient" = 2,
  "Numéro RPPS" = 3,
  "Numéro ADELI" = 4,
  "Numéro SIRIUS" = 5,
  "Numéro étudiant" = 6,
  "Numéro interne d'une structure ADELI" = 7,
  "Numéro interne d'une structure FINESS" = 8,
  "Numéro interne d'une structure SIREN" = 9,
  "Numéro interne d'une structure SIRET" = 10,
  "Numéro interne RPPS" = 11,
  "Numéro interne (autre)" = 12,
}

export interface VaccinatorTelecom {
  type: TelecomTypeEnum;
  usage?: TelecomUsageEnum;
  value: string;
}

export enum TelecomTypeEnum {
  "Numéro de téléphone" = 1,
  "Numéro de FAX" = 2,
  "Adresse électronique" = 3,
  "Adresse HTTP internet ou intranet" = 4,
  "Adresse de transfert de fichier FTP" = 5,
  "Adresse MLLP du protocole HL7" = 6,
  "Type inconnu" = 7,
}

export enum TelecomUsageEnum {
  "Domicile" = 1,
  "Domicile principal" = 2,
  "Lieu de vacances" = 4,
  "Lieu de travail" = 8,
  "Numéro direct" = 16,
  "Numéro publique" = 32,
  "Numéro d'urgence" = 64,
  "Téléphone mobile" = 128,
  "Beeper" = 256,
  "Cas d'usage inconnu" = 512,
}

export interface VaccinatorAddress {
  type?: AddressType;
  country?: string;
  state?: string;
  city?: string;
  postalCode?: string;
  houseNumber?: string;
  houseNumberNumeric?: string;
  streetNameType?: AddressStreetType;
  streetName?: string;
  additionalLocator?: string;
  unitId?: string;
  postBox?: string;
  precInct?: string;
}

export enum AddressType {
  "Domicile" = 1,
  "Domicile principal" = 2,
  "Domicile de vacances" = 3,
  "Lieu de travail" = 4,
  "Adresse temporaire" = 5,
  "Type inconnu" = 6,
}

export enum AddressStreetType {
  "Allée" = 1,
  "Avenue" = 2,
  "Boulevard" = 3,
  "Centre" = 4,
  "Centre Commercial" = 5,
  "Immeuble" = 6,
  "Impasse" = 7,
  "Lieu dit" = 8,
  "Lotissement" = 9,
  "Passage" = 10,
  "Place" = 11,
  "Résidence" = 12,
  "Rond point" = 13,
  "Route" = 14,
  "Rue" = 15,
  "Square" = 16,
  "Village" = 17,
  "Zone d'activité" = 18,
  "Zone d'aménagement concerté" = 19,
  "Zone d'aménagement différé" = 20,
  "Zone industrielle" = 21,
  "Inconnu" = 22,
}

